<template>
    <section class="swipe-menu d-md-none" ref="menu" :class="{'swipe-menu--open':menuIsOpen}">
        <div class="swipe-menu__background" @click="toggleMenu"></div>
        <div class="swipe-menu__content">
            <div class="swipe-menu__icon" @click="openMenu"></div>
            <ul class="p-0">
                <template v-for="(item, index) in list">
                    <li :key="index" @click="handlerClick(item)" v-if="item.showItem">
                        <img v-if="item.icon" :src="assetsPathTheme(item.icon)" />
                        {{item.name}}
                    </li>
                </template>
            </ul>
        </div>
    </section>
</template>
<script>
    import GlobalMixin from '@/app/shared/mixins/global';

export default {
    mixins: [
        GlobalMixin,
    ],
    props: {
        list: {
            default: [],
            type: Array
        }
    },
    data() {
        return {
            menuIsOpen: false,
            touchStartY: 0,
            tolerance: 10,
            delay: 500,
        }
    },
    methods: {
        handlerClick: function(item) {
            this.closeMenu();
            setTimeout(() => {
                if(item.click) {
                    item.click();
                }
            }, this.delay);
        },
        openMenu: function() {
            this.menuIsOpen = !this.menuIsOpen;
        },
        closeMenu: function() {
            this.menuIsOpen = false;
        },
        toggleMenu: function() {
            this.menuIsOpen = !this.menuIsOpen;
        },
        touchStart: function(event) {
            this.touchStartY = event.changedTouches[0].clientY;
        },
        touchEnd: function(event) {
            const touchEndY = event.changedTouches[0].clientY;
            if(touchEndY - this.touchStartY > this.tolerance) {
                this.closeMenu();
                return;
            }

            if(touchEndY - this.touchStartY < -this.tolerance) {
                this.openMenu();
                return;
            }
        },
    },
    mounted() {
        this.$refs.menu.addEventListener("touchstart", this.touchStart , false);
        this.$refs.menu.addEventListener("touchend", this.touchEnd , false);
    },
    beforeDestroy() {
        this.$refs.menu.removeEventListener("touchstart", this.touchStart , false);
        this.$refs.menu.removeEventListener("touchend", this.touchEnd , false);
    },
}
</script>

<style lang="scss" scoped>
@import "@styles/_mixins.scss";
@import "@styles/_theme.scss";
.swipe-menu {
    position: absolute;
    bottom: 0;
    max-height: 5%;
    overflow: hidden;
    right: 0;
    left: 0;
    z-index: $swipe-menu-zindex;
    padding-top: 10px;
    display: flex;
    transition: max-height 1s;

    &--open {
        max-height: 100%;
    }
    &--open &__background {
        top: $swipe-menu-background-top;
        opacity: 1;
    }
    &__background {
        position: fixed;
        background: $swipe-menu-background-color;
        top: 100%;
        left: 0;
        right: 0;
        bottom: 0;
        opacity: 0;
        transition: opacity 1s;
    }
    & &__content{
        width: 100%;
        background: $swipe-menu-content-background;
        box-shadow: $swipe-menu-content-shadow;
        border-radius: $swipe-menu-border-radius $swipe-menu-border-radius 0 0;
        position: relative;
    }
    & &__icon {
        cursor: pointer;
        padding: 12px 0;
        display: block;
        display: flex;
        justify-content: center;
        align-items: center;
        &::before {
            border-radius: 100px;
            background: $swipe-menu-dash-color;
            width: $swipe-menu-dash-width;
            height: $swipe-menu-dash-height;
            content: '';
        }
    }
    ul {
        list-style: none;
        li {
            font-size: 14px;
            color: $swipe-menu-item-color;
            padding: $swipe-menu-item-padding;
            cursor: pointer;
        }
    }
}

</style>
